import React from 'react';
import Styles from "../../../scss/subscriptions.module.scss";
import {ReactComponent as InfoCircleIcon} from "../../../assets/images/icon-info-circle.svg"
export interface IInfoCard{
  title:string;
  content:React.ReactNode;
}
export function InfoCard({title,content}:IInfoCard) {
  return (
    <div className={Styles.InfoCard}>
      <header>
        <InfoCircleIcon/>
        <p>{title}</p>
      </header>
      <p>{content}</p>
    </div>
  )
}
